import { render, staticRenderFns } from "./DotsIcon.vue?vue&type=template&id=2ee93014&"
import script from "./DotsIcon.vue?vue&type=script&lang=ts&"
export * from "./DotsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports